import { render, staticRenderFns } from "./ProfilesProformTable.vue?vue&type=template&id=120d78aa&scoped=true"
import script from "./ProfilesProformTable.vue?vue&type=script&lang=js"
export * from "./ProfilesProformTable.vue?vue&type=script&lang=js"
import style0 from "./ProfilesProformTable.vue?vue&type=style&index=0&id=120d78aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d78aa",
  null
  
)

export default component.exports